import gql from 'graphql-tag';
import ContentFields from '../fragments/content';

export default gql`
  query content(
    $uri: String!
    $limit: Int
    $offset: Int
  ) {
    content(uri: $uri) {
      id

      recentChildContent(
        limit: $limit
        offset: $offset
      ) {
        ...ContentFields
      }
    }
  }
  ${ContentFields}
`;
